import { Input } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../App.css";
import useMultiNotification from "../../hooks/useNotification";
import "../../index.css";
import {
  handleGoBack,
  handleUpdateAdditionalInfo,
  handleUpdateErrorsOfOrderCreamForm,
  handleUpdateOrderCreamLoadingState,
  submitNewOrderCream,
  saveStep9Api,
  getOrderByTransactionIdApi,
} from "../../redux-toolkit/slices/orderCreamSlice";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import ErrorList from "../Items/ErrorsList";

const OcAnythingelse = () => {
  const { openNotification, contextHolder } = useMultiNotification();
  const navigate = useNavigate();
  const orderCreamForm = useSelector((state: RootState) => state.orderCream);
  const { additionalInfo, isError, errors, isLoading, transactionId, currentStep } = orderCreamForm;
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);

  // Fetch order data when component mounts
  useEffect(() => {
    const fetchOrder = async () => {
      if (transactionId) {
        setIsLoadingOrder(true);
        try {
          const orderData = await dispatch(
            getOrderByTransactionIdApi(transactionId)
          ).unwrap();
          // The Redux reducer will automatically populate the state with order data
        } catch (error) {
          console.error("Error loading order:", error);
        } finally {
          setIsLoadingOrder(false);
        }
      }
    };
    
    fetchOrder();
  }, [transactionId, dispatch]);

  const handleBack = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", prevStep.toString());
      setSearchParams(newParams, { replace: true });
      // Don't call handleGoBack() - let the parent component sync from URL
    }
  };
  const handleInputChange = (e: any) => {
    dispatch(handleUpdateAdditionalInfo(e.target.value));
  };

  const handleFormSubmit = async () => {
    // First save step 9
    if (transactionId) {
      try {
        await dispatch(
          saveStep9Api({
            transactionId,
            additionalInfo: additionalInfo || '',
          })
        ).unwrap();
      } catch (error) {
        dispatch(
          handleUpdateErrorsOfOrderCreamForm({
            isError: true,
            errors: ["Failed to save step. Please try again."],
          })
        );
        return;
      }
    }

    dispatch(handleUpdateOrderCreamLoadingState(true));

    try {
      const response = await dispatch(
        submitNewOrderCream({
          ...orderCreamForm,
          getStarted: {
            firstName: orderCreamForm.shippingDetails.firstName,
            lastName: orderCreamForm.shippingDetails.lastName,
            email: orderCreamForm.shippingDetails.email,
          },
        })
      ).unwrap();
      const { message } = response;
      if (message) {
        //  dispatch(handleResetForm(1));
        openNotification(`success`, `Pain Entry`, message);
        setTimeout(() => {
          navigate(`/`);
        }, 3000);
      }
      console.log({ response });
    } catch (error: any) {
      dispatch(handleUpdateOrderCreamLoadingState(false));
      dispatch(
        handleUpdateErrorsOfOrderCreamForm({
          isError: true,
          errors: [
            typeof error === "string"
              ? error
              : "Failed to submit the form. Please try again.",
          ],
        })
      );
      console.log({ error });
    }
    //let's submit the form here
  };
  return (
    <>
      {contextHolder}
      <div className="anything-else-entry">
        <div className="flex flex-col gap-5 w-full">
          {/* Additional Information Question */}
          <div className="flex flex-col gap-2">
            <label className="h6 text-theme-text-secondary">
              <strong>
                Anything else you'd like to share with your doctor?
              </strong>
            </label>
            <Input.TextArea
              value={additionalInfo}
              onChange={handleInputChange}
              rows={4}
              placeholder="Please provide any additional details here."
              className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
            />
          </div>

          {/* Error Display */}
          {isError === true && (
            <div className="mt-6">
              <ErrorList errors={errors} />
            </div>
          )}

          {/* Submit Button */}
          <div
            className="flex justify-center gap-4"
            style={{ marginTop: "40px" }}
          >
            <button
              onClick={handleBack}
              className="caption2 transition-colors duration-200"
              style={{
                color: "var(--primary-500)",
                textDecoration: "none",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              Previous
            </button>
            <button
              disabled={isLoading}
              onClick={handleFormSubmit}
              className={
                isLoading
                  ? "btn btn-secondary btn-lg"
                  : "btn btn-primary btn-lg"
              }
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OcAnythingelse;
